import { View } from 'react-native';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { mergeStyles } from 'src/_shared/utils/mergeStyles';
import { stylesMobile } from './ToolbarTile.styles';
import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { TBaseButtonProps } from '@photosi/rn-components/buttons/base-button/BaseButton.types';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { Tool } from '../BaseToolbar.types';
import { ToolOptionsProps } from '../toolbar-options/tool-options-renderer/ToolOptionsRenderer.types';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/contexts/StoreContext';
import { brand, icon } from 'src/theme/colors';
import { configurationTestID } from 'src/helpers/testIDs.helper';

export type ToolbarTileProps = {
  isExpanded: boolean;
  isSelected: boolean;
  iconName: ICON_NAMES;
  isLookup?: boolean;
} & Tool<ToolOptionsProps> &
  Omit<TBaseButtonProps, 'children'>;

export const ToolbarTileMobile = observer(
  ({ tool, isSelected, isExpanded, iconName, style, isLookup, testID, ...buttonProps }: ToolbarTileProps) => {
    const {
      i18n,
      project: { activeUserImageArea },
    } = useStore();
    const styles = stylesMobile;
    const selected = tool?.choices?.filter(i => i.selected);
    let disabled = false;
    const color = !isLookup ? (styles.icon as any).color : brand.main.water;
    switch (tool.code) {
      case 'undo':
        disabled = !activeUserImageArea?.userImage?.canUndo;
        break;
      case 'redo':
        disabled = !activeUserImageArea?.userImage?.canRedo;
        break;
      case 'restore':
        disabled = !activeUserImageArea?.userImage?.canRestore;
        break;
      default:
        disabled = false;
    }

    const buttonTestID = testID ?? configurationTestID(tool.code);

    return (
      <BaseButton
        testID={buttonTestID}
        style={mergeStyles([
          !isLookup ? styles.button : styles.buttonLookup,
          style,
          !isLookup && isSelected && styles.buttonSelected,
        ])}
        innerStyle={styles.buttonInner}
        focusStyle={styles.buttonFocus}
        hoverStyle={styles.buttonHover}
        disabledStyle={styles.buttonDisabled}
        disabled={disabled}
        {...buttonProps}
      >
        {() => (
          <>
            <View style={styles.icon}>
              <Icon name={iconName} color={disabled ? icon.iconColorDisabled : color} />
            </View>
            <View style={styles.toolDetails}>
              <TextLato style={styles.toolDetailsText}>{i18n.t(tool.titleKey)}</TextLato>
            </View>
            {isLookup && selected && selected.length > 0 && (
              <View style={styles.toolDetails}>
                <TextLato style={styles.toolTextSelected}>{i18n.t(selected?.[0].titleKey)}</TextLato>
              </View>
            )}
          </>
        )}
      </BaseButton>
    );
  },
);

ToolbarTileMobile.displayName = 'ToolbarTile';
